
/* injects from baggage-loader */

const subscribeFormModule = angular.module('subscribe_form.initializer', []);

subscribeFormModule.service("SubscribeFormManager", ["$timeout", "$injector", "ns", "$filter", function($timeout, $injector, ns, $filter) {
    'use strict';

    let Y = undefined;

    return {
      init(y) {
        Y = y;
      },

      findFileldIndexByAttr(fields, attribute) {
        const field = _.filter(fields, attribute)[0];
        return fields.indexOf(field);
      },

      updateOptions(widget) {
        const options = window.justclick;
        const $widgetElWrapper = $(`[data-block-id="${widget.id}"]`);
        const formAction = options.overrideFormAction !== undefined
            ? options.overrideFormAction
            : '/subscribe/process';

        $widgetElWrapper.find('form').attr('action', formAction)

        if (options.ignoreSelectedProducts !== undefined) {
          widget.submit_action = 'make_order';
        }

        widget.disable_form_settings = options.disableFormSettings !== undefined
            ? options.disableFormSettings
            : false;

        widget.update_form_settings_url = options.updateFormSettingsUrl !== undefined
            ? options.updateFormSettingsUrl
            : '';

        widget.stripe_key = options.stripePublicKey;
        widget.single_opt_in = options.isSingleOptInSubscribe;
        widget.override_form_action = options.overrideFormAction;

        // Обновление поля ADDRESS_FIELD и показ/скрытие полей DELIVERY_ADDRESS_FIELDS
        const ADDRESS_FIELD = 'orderData[bill_hide_shipping_address]';
        const DELIVERY_ADDRESS_FIELDS = [
          'orderData[bill_shipping_name]',
          'orderData[bill_shipping_phone]',
          'orderData[bill_country]',
          'orderData[bill_address]',
          'orderData[bill_address2]',
          'orderData[bill_city]',
          'orderData[bill_region]',
          'orderData[bill_postal_code]',
        ];
        const indexAddressField = this.findFileldIndexByAttr(widget.form_fields_attributes, {name: ADDRESS_FIELD});
        if (indexAddressField > 0) {
          if (widget.form_fields_attributes[indexAddressField].placeholder === '') {
            widget.form_fields_attributes[indexAddressField].placeholder = $filter('translate')('widget.form.DeliveryAddressIsBillingAddress');
            widget.form_fields_attributes[indexAddressField].exist = false;
          }
          if (widget.form_fields_attributes[indexAddressField].checked === undefined) {
            widget.form_fields_attributes[indexAddressField].checked = true;
          }

          DELIVERY_ADDRESS_FIELDS.map((field) => {
            const $field = $widgetElWrapper.find('form').find('[name="' + field + '"]');

            if ($field.length > 0) {
              const $fieldWrapper = $field.closest('.strwf__input-wrapper');
              const hasInvisibleCssClass = $fieldWrapper.hasClass('strwf__input-wrapper_invisible');

              if (widget.form_fields_attributes[indexAddressField].checked) {
                if (!hasInvisibleCssClass) {
                  $fieldWrapper.addClass('strwf__input-wrapper_invisible');
                }
              } else {
                if (hasInvisibleCssClass) {
                  $fieldWrapper.removeClass('strwf__input-wrapper_invisible');
                }
              }
            }
          });
        }

        return widget;
      },

      destroy() {

      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/subscribe_form/subscribeForm.initializer.js